module.exports = __webpack_public_path__ + "img/feature-lister.b6bb651c.png";